import { Component, OnInit, Input, Inject } from '@angular/core';
import * as Tokens from '@shared/core/tokens';
@Component({
    selector: 'shared-bg-overlay',
    templateUrl: './bg-overlay.shared.component.html',
    styleUrls: ['./bg-overlay.shared.component.scss']
})
export class BgOverlayComponent implements OnInit {
    @Input() public type: string;

    public isHalfAngled: boolean = false;
    public isFull: boolean = false;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
    ) { }

    ngOnInit(): void {
        if (!this.type) {
            this.type = this.config.ui && this.config.ui.heroBackground && this.config.ui.heroBackground.overlay || null;
        }

        if (this.type === 'full') {
            this.isFull = true;
        }

        if (this.type === 'half-angled') {
            this.isHalfAngled = true;
        }
    }
}
